import { render, staticRenderFns } from "./CaseDialog.vue?vue&type=template&id=e2457744"
import script from "./CaseDialog.vue?vue&type=script&lang=js"
export * from "./CaseDialog.vue?vue&type=script&lang=js"
import style0 from "./CaseDialog.vue?vue&type=style&index=0&id=e2457744&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports